import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Calendar, Heart, Brain, Target } from 'lucide-react';
export function ContentSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const tomos = [{
    icon: <BookOpen className="w-5 h-5 text-white" data-id="element-106" />,
    title: 'Organización del Tiempo',
    color: '#00A3FF',
    shadowColor: 'rgba(0, 163, 255, 0.5)'
  }, {
    icon: <Calendar className="w-5 h-5 text-white" data-id="element-107" />,
    title: 'Planificación Académica',
    color: '#9D4EDD',
    shadowColor: 'rgba(157, 78, 221, 0.5)'
  }, {
    icon: <Heart className="w-5 h-5 text-white" data-id="element-108" />,
    title: 'Rendimiento y Bienestar',
    color: '#00C853',
    shadowColor: 'rgba(0, 200, 83, 0.5)'
  }, {
    icon: <Brain className="w-5 h-5 text-white" data-id="element-109" />,
    title: 'Métodos de Estudio Eficientes',
    color: '#FF6D00',
    shadowColor: 'rgba(255, 109, 0, 0.5)'
  }, {
    icon: <Target className="w-5 h-5 text-white" data-id="element-110" />,
    title: 'Estrategias para Exámenes',
    color: '#FF007F',
    shadowColor: 'rgba(255, 0, 127, 0.5)'
  }];
  return <section id="que-incluye" className="w-full py-24 bg-transparent px-4 relative" data-id="element-111">
      <div className="max-w-2xl mx-auto flex flex-col items-center relative z-10" data-id="element-112">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-black text-white mb-16 text-center max-w-4xl leading-tight" data-id="element-113">
          ¿Qué incluye el MegaPack Universitario Cursada Sin Estrés?
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="flex flex-col gap-3 w-full" data-id="element-114">
          {tomos.map((tomo, index) => <motion.div key={index} variants={itemVariants} className="group relative bg-[#130F1C] rounded-xl p-4 md:p-5 border border-white/5 overflow-hidden w-full transition-all duration-500 hover:-translate-y-1" style={{
          '--hover-color': tomo.color
        } as React.CSSProperties} data-id="element-115">
              {/* Borde iluminado en hover */}
              <div className="absolute inset-0 rounded-xl border-2 border-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
            borderColor: tomo.color,
            boxShadow: `inset 0 0 20px ${tomo.shadowColor}`
          }} data-id="element-116" />

              {/* Resplandor inferior */}
              <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 w-[80%] h-[60px] blur-[40px] opacity-40 group-hover:opacity-80 group-hover:h-[100px] transition-all duration-500 pointer-events-none" style={{
            backgroundColor: tomo.color
          }} data-id="element-117" />

              <div className="relative z-10" data-id="element-118">
                <div className="flex justify-between items-center mb-3" data-id="element-119">
                  {/* Icono */}
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center shadow-lg" style={{
                backgroundColor: tomo.color
              }} data-id="element-120">
                    {tomo.icon}
                  </div>

                  {/* Pill */}
                  <div className="px-3 py-1 rounded-full border border-white/10 bg-white/5 text-xs font-black text-white/80 tracking-widest uppercase" data-id="element-121">
                    TOMO {index + 1}
                  </div>
                </div>

                {/* Título */}
                <h3 className="text-lg md:text-xl font-black text-white tracking-tight" data-id="element-122">
                  {tomo.title}
                </h3>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}